/* ===========================================================
   KULTTIJULISTE - SISUSTUSKUVA TUOTESIVULLE  8.8.2026

   Rakentaa tuotesivulle toisen kuvan, jossa juliste on
   kehystettynä oikean huonevalokuvan päällä. Kuvat ja kehys
   ovat kiinteitä (CSS), niiden päälle asetetaan tuotteen oma
   pääkuva. Uusia kuvatiedostoja ei tarvita per tuote - sama
   4 huonekuvaa ja 4 kehysvaihtoehtoa toimivat yhtä hyvin
   150 kuin 5000 tuotteella.

   Asiakas voi vaihtaa huoneen ja kehyksen. Molemmat valinnat
   muistetaan seuraaville tuotesivuille (localStorage).
   =========================================================== */
(function () {
  var WALL_KEY = 'kjWall';
  var FRAME_KEY = 'kjFrame';
  var WALLS = ['light', 'dark', 'brick', 'cozy'];
  var FRAMES = ['black', 'oak', 'white', 'gold'];

  var T = {
    fi: {
      wallLabel: 'Huone:',
      frameLabel: 'Kehys:',
      note: 'Kuvituskuva – kehys ei sisälly toimitukseen.',
      alt: 'juliste kehystettynä seinällä',
      wallNames: { light: 'Vaalea olohuone', dark: 'Tumma seinä', brick: 'Tiiliseinä', cozy: 'Kodikas olohuone' },
      frameNames: { black: 'Musta kehys', oak: 'Tammenvärinen kehys', white: 'Valkoinen kehys', gold: 'Kultainen kehys' }
    },
    en: {
      wallLabel: 'Room:',
      frameLabel: 'Frame:',
      note: 'Illustrative image – frame not included.',
      alt: 'poster framed on a wall',
      wallNames: { light: 'Bright living room', dark: 'Dark wall', brick: 'Brick wall', cozy: 'Cozy living room' },
      frameNames: { black: 'Black frame', oak: 'Oak frame', white: 'White frame', gold: 'Gold frame' }
    },
    sv: {
      wallLabel: 'Rum:',
      frameLabel: 'Ram:',
      note: 'Illustrationsbild – ramen ingår inte.',
      alt: 'affisch inramad på en vägg',
      wallNames: { light: 'Ljust vardagsrum', dark: 'Mörk vägg', brick: 'Tegelvägg', cozy: 'Mysigt vardagsrum' },
      frameNames: { black: 'Svart ram', oak: 'Ekfärgad ram', white: 'Vit ram', gold: 'Guldram' }
    }
  };

  function lang() {
    var p = window.location.pathname;
    if (/^\/en(\/|$)/.test(p)) return 'en';
    if (/^\/sv(\/|$)/.test(p)) return 'sv';
    return 'fi';
  }

  function savedValue(key, allowed, fallback) {
    try {
      var v = window.localStorage.getItem(key);
      if (allowed.indexOf(v) !== -1) return v;
    } catch (e) {}
    return fallback;
  }

  function saveValue(key, v) {
    try { window.localStorage.setItem(key, v); } catch (e) {}
  }

  /* Pyydetään Shopifyn CDN:ltä sopivan levyinen versio kuvasta. */
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    var hash = '';
    var hi = url.indexOf('#');
    if (hi !== -1) { hash = url.slice(hi); url = url.slice(0, hi); }

    var parts = url.split('?');
    var base = parts[0];
    var query = parts.length > 1 ? parts[1] : '';

    var kept = [];
    if (query) {
      var pairs = query.split('&');
      for (var i = 0; i < pairs.length; i++) {
        if (!pairs[i]) continue;
        if (pairs[i].indexOf('width=') === 0) continue;
        if (pairs[i].indexOf('height=') === 0) continue;
        kept.push(pairs[i]);
      }
    }
    kept.push('width=' + w);
    return base + '?' + kept.join('&') + hash;
  }

  function buildSelector(opts) {
    /* opts: { list, attr, values, names, label, current, onPick } */
    var bar = document.createElement('div');
    bar.className = 'kj-mockup-bar kj-mockup-bar--' + opts.attr;

    var lab = document.createElement('span');
    lab.className = 'kj-mockup-bar__label';
    lab.textContent = opts.label;
    bar.appendChild(lab);

    opts.values.forEach(function (name) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-' + opts.attr, name);
      b.setAttribute('aria-pressed', String(name === opts.current));
      b.setAttribute('aria-label', opts.names[name]);
      b.title = opts.names[name];
      b.addEventListener('click', function () {
        opts.onPick(name);
        Array.prototype.forEach.call(bar.querySelectorAll('button'), function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
      });
      bar.appendChild(b);
    });

    return bar;
  }

  function build() {
    var list = document.querySelector('.product__media-list');
    if (!list || list.querySelector('.kj-mockup-item')) return;

    var firstItem = list.querySelector('.product__media-item');
    if (!firstItem) return;

    var img = firstItem.querySelector('img');
    if (!img) return;

    var w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
    var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
    if (!w || !h) return;

    var src = img.currentSrc || img.src;
    if (!src) return;

    var t = T[lang()];
    var wall = savedValue(WALL_KEY, WALLS, 'light');
    var frame = savedValue(FRAME_KEY, FRAMES, 'black');

    var li = document.createElement('li');
    /* Samat asettelu-luokat kuin Dawnin omilla kuvilla, jotta
       leveys ja mobiilikaruselli toimivat oikein. */
    li.className = 'product__media-item grid__item slider__slide kj-mockup-item';

    var box = document.createElement('div');
    box.className = 'kj-mockup';
    box.setAttribute('data-wall', wall);
    box.setAttribute('data-frame', frame);
    box.setAttribute('data-orientation', w > h ? 'landscape' : 'portrait');
    /* KJ 27.8.2026: kehyksen muoto seuraa nyt TAMAN tuotteen oikeaa
       kuvasuhdetta (esim. A1 59.4x84.1cm vs Maxi 61x91.5cm), eika
       kiinteaa maxi-julisteen suhdetta - katso poster-mockup.css. */
    box.style.setProperty('--kj-ar', w + ' / ' + h);

    var scene = document.createElement('div');
    scene.className = 'kj-mockup__scene';

    var frameEl = document.createElement('div');
    frameEl.className = 'kj-mockup__frame';

    var poster = document.createElement('img');
    poster.src = sized(src, 900);
    poster.alt = (img.getAttribute('alt') || '') + ' — ' + t.alt;
    poster.setAttribute('loading', 'lazy');

    var glass = document.createElement('div');
    glass.className = 'kj-mockup__glass';

    frameEl.appendChild(poster);
    box.appendChild(scene);
    box.appendChild(frameEl);
    box.appendChild(glass);
    li.appendChild(box);

    /* Huonevalitsin */
    var wallBar = buildSelector({
      attr: 'wall',
      label: t.wallLabel,
      values: WALLS,
      names: t.wallNames,
      current: wall,
      onPick: function (name) {
        box.setAttribute('data-wall', name);
        saveValue(WALL_KEY, name);
      }
    });
    li.appendChild(wallBar);

    /* Kehysvalitsin */
    var frameBar = buildSelector({
      attr: 'frame',
      label: t.frameLabel,
      values: FRAMES,
      names: t.frameNames,
      current: frame,
      onPick: function (name) {
        box.setAttribute('data-frame', name);
        saveValue(FRAME_KEY, name);
      }
    });
    li.appendChild(frameBar);

    var note = document.createElement('p');
    note.className = 'kj-mockup-note';
    note.textContent = t.note;
    li.appendChild(note);

    list.appendChild(li);
  }

  function run() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    build();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
